import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import RelatedPulseLinks from '../../shared/RelatedPulseLinks';
dayjs.extend(advancedFormat);

// Keep Ghost copy and attributes intact while nesting its sections below the page title.
function articleHTML(html) {
  const fragment = DOMPurify.sanitize(html, { RETURN_DOM_FRAGMENT: true });
  const levels = [];
  fragment.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(heading => {
    const sourceLevel = Number(heading.tagName.slice(1));
    while (levels.length && levels[levels.length - 1] >= sourceLevel) levels.pop();
    const replacement = document.createElement(`h${Math.min(6, levels.length + 2)}`);
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    replacement.append(...heading.childNodes);
    heading.replaceWith(replacement);
    levels.push(sourceLevel);
  });
  const container = document.createElement('div');
  container.append(fragment);
  return container.innerHTML;
}

export default function ViewArticle({ article, guide = false }) {
  const html = useMemo(() => articleHTML(article.html), [article.html]);
  return (
    <article className={`blog pulse-article${guide ? ' pulse-guide-article' : ''}`}>
      <Link className="pulse-back" to="/pulse/all">← Back to Pulse</Link>
      <header className="pulse-article-header">
        <h1>{article.title}</h1>
        {!guide && <p className="pulse-article-excerpt">{article.excerpt}</p>}
        <div className="pulse-byline">
          {article.authors[0]?.profile_image && <img src={article.authors[0].profile_image} alt="" className="pulse-avatar" />}
          <div><span>{article.authors.map(author => author.name).join(', ')}</span>
            <time dateTime={guide ? article.published_at : article.updated_at}>{dayjs(guide ? article.published_at : article.updated_at).format('ddd MMM Do')}</time>
          </div>
        </div>
      </header>
      {article.feature_image && <img className="pulse-feature-image" src={article.feature_image} alt={article.feature_image_alt || ''} />}
      <div className="pulse-prose" dangerouslySetInnerHTML={{ __html: html }} />
      {!guide && <RelatedPulseLinks articles={[]} label="More from ShuttleOps Pulse" links={[
        { path: '/pulse/all', title: 'All articles, guides and comparisons' },
        { path: '/guides/club-attendance-register', title: 'Club attendance register and free template' },
        { path: '/calculator', title: 'Club value calculator' },
      ]} />}
    </article>
  );
}
